import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  checkPermisson,
  getMarkets,
} from '../../../../selectors/common';
import { selectorMarketMargins } from '../../../../selectors/marketMargins';
import MarketMargins from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetMarketMarginsRequest, aUpdateMarketMarginsRequest } from '../../../../reducers';
import { aClearMarketMargins } from '../../../../reducers/marketMargins';

const mapToProps = (state) => ({
  checkPermisson: (payload) => checkPermisson(state, payload),
  marketMargins: selectorMarketMargins(state),
  allMarkets: getMarkets(state),
});

const actionsToProps = (dispatch) => ({
  getMargins: (payload) => dispatch(aGetMarketMarginsRequest(payload)),
  updateMarketMargins: (payload) => dispatch(aUpdateMarketMarginsRequest(payload)),
  clearMarketMargins: (payload) => dispatch(aClearMarketMargins(payload)),

});

const MarketMarginsSoccer = (props) => {
  const navigate = useNavigate();

  return (
    <MarketMargins
      navigate={navigate}
      getMargins={props.getMargins}
      clearMarketMargins={props.clearMarketMargins}
      marketMargins={props.marketMargins}
      allMarkets={props.allMarkets}
      updateMarketMargins={props.updateMarketMargins}
      hasPermissionToUpdate={props.checkPermisson(PERMISSIONS.MARKET_MARGINS_UPDATE)}
    />
  );
};

export default connect(mapToProps, actionsToProps)(MarketMarginsSoccer);
